<template>
  <filter-button
    :count-filtered="countFiltered"
    :disabled-clear="!isClearFilter"
    :disabled-apply="!isChangeFilter"
    @cancel="handleCancelFilter"
    @clear="handleClearFilter"
    @apply="handleSearchFilter"
  >
    <template v-slot:content>
      <v-list-item class="mt-2 ml-5 mr-5 fixWidth d-block">
        <p class="filterContentTitle sub-body-bold mb-0" t-data="type-title">Banner Type</p>
        <v-select
          class="can-disable-selector selector-filter"
          t-data="type-selector"
          placeholder="All Banner"
          :items="typeList"
          outlined
          required
          color="primary500Color"
          dense
          v-model="typeSelected"
          item-text="text"
          item-value="value"
        ></v-select>
      </v-list-item>

      <v-list-item class="ml-2 mr-2 mt-2">
        <div class="d-flex flex-column justify-start align-start">
          <p class="mb-0 filterContentTitle sub-body-bold">Status</p>
          <template v-for="(item, i) in statusItems">
            <v-checkbox
              color="#9E8819"
              :key="i"
              v-model="statusSelected"
              :label="item.text"
              :value="item.value"
              class="mt-0 filterContent body-regular"
              hide-details
            ></v-checkbox>
          </template>
        </div>
      </v-list-item>
    </template>
  </filter-button>
</template>

<script>
import {mapActions} from 'vuex'
import FilterButton from '@/components/FilterButton'
import {heroBannerStatus, typeEnum, typeText} from '@/constants/hero-banner'
var _ = require('lodash')

export default {
  name: 'FilterDropdown',
  data: () => ({
    typeSelected: null,
    statusSelected: [],
    countFiltered: 0,
    isChanged: false,
    appliedType: null,
    appliedStatus: [],
  }),
  components: {
    FilterButton,
  },
  computed: {
    statusItems() {
      const items = []
      Object.keys(heroBannerStatus).forEach(key => {
        items.push({
          text: heroBannerStatus[key],
          value: key
        })
      });
      return items
    },
    typeList() {
      const items = []
      Object.keys(typeEnum).forEach(key =>
        items.push({
          text: typeText[key],
          value: key
        })
      )
      return items
    },
    isClearFilter() {
      const changedType = !_.isEqual(this.typeSelected, null)
      const changedStatus = !_.isEqual(this.statusSelected, [])
      return changedType || changedStatus
    },
    isChangeFilter() {
      const changedType = !_.isEqual(this.typeSelected, this.appliedType)
      const changedStatus = !_.isEqual(this.statusSelected, this.appliedStatus)
      return changedType || changedStatus
    },
    hasOneOrg() {
      return this.orgList.all.length === 1
    },
  },
  methods: {
    sumFiltered() {
      const sumType = this.typeSelected === null ? 0 : 1
      const sumStatus = this.statusSelected.length > 0 ? 1 : 0
      return sumType + sumStatus
    },
    handleSearchFilter() {
      this.$emit('apply')
      this.appliedType = this.typeSelected
      this.appliedStatus = this.statusSelected
      this.setFilterType(this.typeSelected)
      this.setFilterStatus(this.statusSelected)
      this.fetch()
      this.countFiltered = this.sumFiltered()
    },
    handleClearFilter() {
      this.statusSelected = []
      this.typeSelected = null
      this.isChanged = true
    },
    handleCancelFilter() {
      // wait for multiple select render
      this.$nextTick(() => {
        this.typeSelected = this.appliedType
        this.statusSelected = this.appliedStatus
        this.setFilterType(this.typeSelected)
        this.setFilterStatus(this.statusSelected)
        this.countFiltered = this.sumFiltered()
      })
    },
    ...mapActions('heroBanner', ['fetch', 'setFilterStatus', 'setFilterType'])
  }
}
</script>
<style scoped>
::v-deep .v-list-item__title{
  font-size: 16px !important;
}
</style>
